module.exports = __webpack_public_path__ + "static/media/enrollment_warning.86e818c0.svg";